import { Button, Flex } from '@chakra-ui/react';
import React from 'react';

import SelectedFloatingFooter from 'components/Table/SelectedFloatingFooter';

interface IWorkersMappingTableFooter {
  selectedFlatRows: any[];
  toggleAllRowSelected: (value?: boolean) => void;
  handleImportWorkers: (value: any[]) => void;
  handleBulkMapUnmapEmployees: (value: any[], type: 'map' | 'unmap') => void;
  isLoading: boolean;
  isBulkMapBtnLoading: boolean;
  isBulkUnmapBtnLoading: boolean;
  t: any;
  mappedUsers: any;
}

const WorkersMappingTableFooter: React.FC<IWorkersMappingTableFooter> = ({
  selectedFlatRows,
  toggleAllRowSelected,
  handleImportWorkers,
  handleBulkMapUnmapEmployees,
  isLoading,
  isBulkMapBtnLoading,
  isBulkUnmapBtnLoading,
  mappedUsers,
  t,
}) => {
  const selectedIds: Array<any> = [];
  let showbulkUnmapButton = false;
  let showBulkMapButton = false;

  // const selected = selectedFlatRows.map((item: any) => item.original.associateOID);

  // const hasMappedUsers = selectedFlatRows.find((item: any) => item.original.selected_user) ? true : false;

  selectedFlatRows.forEach(row => {
    if (!selectedIds.includes(row.original.id)) {
      selectedIds.push(row.original.id);
    }

    if (row.original.selected_user) {
      showbulkUnmapButton = true;
    }

    if (mappedUsers && Object.keys(mappedUsers).includes(String(row.original.id))) {
      showBulkMapButton = true;
    }
  });

  return (
    <SelectedFloatingFooter selectedFlatRows={selectedFlatRows} toggleAllRowSelected={toggleAllRowSelected}>
      <Flex justifyContent="flex-end">
        <Button mr="2" isLoading={isLoading} variant="primary-ghost" onClick={() => handleImportWorkers(selectedIds)}>
          {t('integrations:importWorkers')}
        </Button>
        {showBulkMapButton ? (
          <Button
            mr="2"
            isLoading={isBulkMapBtnLoading}
            variant="primary-ghost"
            onClick={() => handleBulkMapUnmapEmployees(selectedFlatRows, 'map')}
          >
            {t('integrations:adp.bulkMap')}
          </Button>
        ) : null}
        {showbulkUnmapButton ? (
          <Button
            isLoading={isBulkUnmapBtnLoading}
            variant="secondary-ghost"
            onClick={() => handleBulkMapUnmapEmployees(selectedFlatRows, 'unmap')}
          >
            {t('integrations:adp.bulkUnMap')}
          </Button>
        ) : null}
      </Flex>
    </SelectedFloatingFooter>
  );
};

export default WorkersMappingTableFooter;
